// src/components/ProtectedRoute/Admin/Consoles/Framework/ConsoleTable.jsx
import * as React from "react";
import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export default function ConsoleTable({
  columns,
  rows,
  total,
  page,
  onPageChange,
  pageSize,
  onPageSizeChange,
  sortModel,
  onSortModelChange,
  onRowClick,      // 任意: ダブルクリックで編集など
  loading,
  height = 640,
  sx = {},         // DataGrid への追加スタイル
}) {
  // 行高を可変にし、セル内の複数行テキスト（著者リストなど）を表示できるようにする
  const mergedSx = {
    "& .MuiDataGrid-cell": {
      alignItems: "flex-start",
      whiteSpace: "normal",
      lineHeight: 1.4,
      py: 1,
    },
    "& .col-actions": { whiteSpace: "nowrap", py: 0.5 },
    ...sx,
  };

  return (
    <Box sx={{ height, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(r) => r.id} // publications は id 文字列（CompositeでもOK）
        rowCount={total}

        // サーバーモード
        paginationMode="server"
        sortingMode="server"

        // ページング
        paginationModel={{ page, pageSize }}
        onPaginationModelChange={(m) => {
          if (m.page !== page) onPageChange?.(m.page);
          if (m.pageSize !== pageSize) onPageSizeChange?.(m.pageSize);
        }}

        // ソート
        sortModel={sortModel}
        onSortModelChange={onSortModelChange}

        // UX
        disableRowSelectionOnClick
        onRowDoubleClick={(p) => onRowClick?.(p.row)}
        loading={loading}

        // ★ ここがポイント：ポップアップ類はポータル無効（Dialog配下に描画）
        slotProps={{
          basePopper: { disablePortal: true },
        }}

        // 複数行テキストのために行高を自動化
        getRowHeight={() => "auto"}
        sx={mergedSx}
      />
    </Box>
  );
}
